import { useCallback } from 'react';

/**
 * @param {object[]} rows The table rows.
 * @param {string} searchString The search string.
 * @param {Function} setRows The setter for the table rows.
 * @returns {Array} The setter for the table row selection.
 */
const useSetExpandRow = (rows, setRows) => {
  const setExpandRow = useCallback(
    (rowID) => {
      setRows(
        rows.map((row) => {
          if (rowID === row.id) {
            return { ...row, expanded: row.expanded ? !row.expanded : true };
          } else {
            return row;
          }
        })
      );
    },
    [rows, setRows]
  );
  return [setExpandRow];
};

export default useSetExpandRow;
